import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "./i18n";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import RegisterModal, { getStoredUser } from "./components/RegisterModal";
import Splash from "./components/Splash";
import QuotaModal from "./components/QuotaModal";
import CookieBanner from "./components/CookieBanner";
import PwaInstallPrompt from "./components/PwaInstallPrompt";
import VoiceFab from "./components/VoiceFab";
import WelcomeBackModal from "./components/WelcomeBackModal";
import DecisionHub from "./pages/DecisionHub";
import Market from "./pages/Market";
import Comparator from "./pages/Comparator";
import Simulator from "./pages/Simulator";
import Geography from "./pages/Geography";
import Assistant from "./pages/Assistant";
import Profile from "./pages/Profile";
import Glossary from "./pages/Glossary";
import Pricing from "./pages/Pricing";
import PricingSuccess from "./pages/PricingSuccess";
import HowItWorks from "./pages/HowItWorks";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Reviews from "./pages/Reviews";
import WatchlistAlerts from "./pages/WatchlistAlerts";
import PrivacySettings from "./pages/PrivacySettings";
import Coach from "./pages/Coach";
import Login from "./pages/Login";
import Admin from "./pages/Admin";

function AuthGate() {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(getStoredUser());

  useEffect(() => {
    if (!user) {
      // Hard auth gate: open registration immediately after splash (no dismiss).
      const timer = setTimeout(() => {
        const fresh = getStoredUser();
        if (fresh) {
          setUser(fresh);
        } else {
          setOpen(true);
        }
      }, 2200);
      return () => clearTimeout(timer);
    }
  }, [user]);

  // Programmatic open from any page (e.g. QuotaModal "Cadastrar gratuitamente" button)
  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("goldora:open-register", handler);
    return () => window.removeEventListener("goldora:open-register", handler);
  }, []);

  return (
    <RegisterModal
      open={open}
      onClose={() => { /* forced — cannot dismiss without registering */ }}
      onRegistered={(u) => { setUser(u); setOpen(false); }}
      forced={!user}
    />
  );
}

function App() {
  return (
    <I18nProvider>
      <div className="App min-h-screen bg-black text-neutral-100">
        <BrowserRouter>
          <Navbar />
          <main className="pt-[64px] lg:pt-0">
            <Routes>
              <Route path="/" element={<DecisionHub />} />
              <Route path="/mercado" element={<Market />} />
              <Route path="/comparador" element={<Comparator />} />
              <Route path="/simulador" element={<Simulator />} />
              <Route path="/geografia" element={<Geography />} />
              <Route path="/assistente" element={<Assistant />} />
              <Route path="/perfil" element={<Profile />} />
              <Route path="/glossario" element={<Glossary />} />
              <Route path="/planos" element={<Pricing />} />
              <Route path="/planos/sucesso" element={<PricingSuccess />} />
              <Route path="/como-funciona" element={<HowItWorks />} />
              <Route path="/sobre" element={<About />} />
              <Route path="/privacidade" element={<Privacy />} />
              <Route path="/termos" element={<Terms />} />
              <Route path="/avaliacoes" element={<Reviews />} />
              <Route path="/watchlist" element={<WatchlistAlerts />} />
              <Route path="/coach" element={<Coach />} />
              <Route path="/login" element={<Login />} />
              <Route path="/cadastro" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/conta/privacidade" element={<PrivacySettings />} />
            </Routes>
          </main>
          <Footer />
          <AuthGate />
          <QuotaModal />
          <CookieBanner />
          <PwaInstallPrompt />
          <VoiceFab />
          <WelcomeBackModal />
          <Splash />
        </BrowserRouter>
      </div>
    </I18nProvider>
  );
}

export default App;
